import { DateTime } from "luxon";
import { RequestModel } from "model";

import {
  CustomDateValueType,
  FilterDateValueTypes,
} from "~components/Organisms/IndexFilters/types";

import { doesReqMatchSegment, SegmentNameUnion } from "./hooks";

export function matchesSchool(item: RequestModel, schools?: string[]) {
  if (!schools) {
    return true;
  }
  if (schools.length === 0) {
    return true;
  }
  return schools.includes(item.school.id);
}

type matchesDateProps = {
  item: RequestModel;
  dateOption: FilterDateValueTypes;
  customDate?: CustomDateValueType;
  now?: DateTime;
};

export function matchesDate(props: matchesDateProps): boolean {
  const { item, dateOption, customDate, now = DateTime.now() } = props;
  const itemStart = item.startDate; // DateTime
  const itemEnd = item.endDate; // DateTime

  // If no filter, always match
  if (!dateOption) return true;

  // Use the item's timezone, or default to local

  // Helper to check if an interval includes a given day
  function matchesDay(day: DateTime) {
    // If the event overlaps with any time during the day
    const dayStart = day.startOf("day");
    const dayEnd = day.endOf("day");
    return itemStart <= dayEnd && itemEnd >= dayStart;
  }

  if (dateOption === "today") {
    return matchesDay(now);
  }
  if (dateOption === "tomorrow") {
    return matchesDay(now.plus({ days: 1 }));
  }
  if (dateOption === "yesterday") {
    return matchesDay(now.minus({ days: 1 }));
  }

  if (dateOption === "custom") {
    if (!customDate?.start || !customDate?.end) {
      return false;
    }
    const customStart = DateTime.fromISO(customDate.start);
    const customEnd = DateTime.fromISO(customDate.end);
    // Does the item's interval overlap with the custom range?
    return itemStart <= customEnd && itemEnd >= customStart;
  }

  return true;
}

export function matchesStatus(item: RequestModel, statuses?: SegmentNameUnion[]) {
  if (!statuses) {
    return true;
  }
  if (statuses.length === 0) {
    return true;
  }

  return statuses.some((status) => doesReqMatchSegment(status, item));
}
